/**
 * Simple placeholder renderer for schedule notification templates.
 * Replaces placeholders like {primeiro_nome}, {nome_completo}, {data_hora}, {servicos}, {valor_total}, {codigo_agendamento}.
 * This is intentionally simple (string replace) and used for previewing messages on the frontend.
 */

export const renderTemplate = (
  template: string,
  data: Record<string, any> = {},
): string => {
  if (!template) return "";

  let out = String(template);

  const replacements: Record<string, string> = {
    primeiro_nome: data.primeiro_nome || "Cliente",
    nome_completo: data.nome_completo || "Cliente Exemplo",
    profissional_nome: data.profissional_nome || "Profissional",
    data_hora: data.data_hora || data.data || "--/--/---- --:--",
    data: data.data || "--/--/----",
    hora: data.hora || "--:--",
    servicos: Array.isArray(data.servicos)
      ? data.servicos.join(", ")
      : String(data.servicos || "—"),
    valor_total: data.valor_total || data.valor || "R$ 0,00",
    codigo_agendamento:
      data.codigo_agendamento || String(data.id || data.codigo || "#000"),
  };

  Object.keys(replacements).forEach((key) => {
    const re = new RegExp(`\\{${key}\\}`, "g");
    out = out.replace(re, replacements[key]);
  });

  return out;
};

export default { renderTemplate };
